(() => {
  let pending = false;
  const selector = 'button[name="add"], .product-form__submit, #AddToCart, [data-add-to-cart]';
  const isAddForm = form => form instanceof HTMLFormElement && new URL(form.action).pathname.match(/\/cart\/add(?:\.js)?$/);
  function bundle(form) {
    const selection = window.dropMagicSelectedBar;
    const config = window.dropMagicBarConfigs?.[selection?.barId];
    const id = new FormData(form).get('id');
    return config && window.dropMagicProductConfig?.variants?.some(v => String(v.id) === String(id))
      ? { config, barId: selection.barId } : null;
  }
  function showError(form, message) {
    let error = form.querySelector('[data-ap-checkout-error]');
    if (!error) {
      error = document.createElement('p');
      error.dataset.apCheckoutError = '';
      error.setAttribute('role', 'alert');
      error.tabIndex = -1;
      form.append(error);
    }
    error.textContent = message;
    error.focus();
  }
  async function checkout(form, button) {
    if (pending || button?.disabled || button?.getAttribute('aria-disabled') === 'true') return;
    if (!form.reportValidity()) return;
    pending = true;
    const oldBusy = button?.getAttribute('aria-busy');
    button?.setAttribute('aria-busy', 'true');
    const error = form.querySelector('[data-ap-checkout-error]');
    if (error) error.textContent = '';
    try {
      const selected = bundle(form);
      if (form.dataset.apOfferRequired === 'true' && !selected) throw new Error();
      let response;
      if (selected) {
        if (window.dropMagicVariantFetchReady) await window.dropMagicVariantFetchReady;
        const {config, barId} = selected;
        const bar = [...document.querySelectorAll('[data-bar-id]')].find(el => el.dataset.barId === barId);
        let items = window.buildCartItems(config, barId, bar);
        if (!items.length) throw new Error();
        if (config.barType === 'bxgy') {
          items = items.filter(i => i.properties._bundle_type === 'get')
            .concat(items.filter(i => i.properties._bundle_type === 'buy'))
            .concat(items.filter(i => !['get', 'buy'].includes(i.properties._bundle_type)));
        }
        if (!window.addItemsWithSections?.apVictorySellingPlanWrapped) throw new Error();
        response = await window.addItemsWithSections(items);
      } else {
        const result = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
          method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)
        });
        response = await result.json();
        if (!result.ok || response.status) throw new Error();
      }
      if (!response || response.status || !(response.id || response.items?.length)) throw new Error();
      // Pixel failures must not turn a confirmed add into a retry and duplicate purchase.
      try { window.trackDropMagicAddToCart?.(response.items || [response]); } catch (_) {}
      window.location.assign((window.Shopify?.routes?.root || '/') + 'checkout');
    } catch (_) {
      pending = false;
      if (oldBusy === null) button?.removeAttribute('aria-busy');
      else if (oldBusy !== undefined) button?.setAttribute('aria-busy', oldBusy);
      showError(form, document.documentElement.dataset.apCheckoutError || window.Theme?.translations?.cart_error || 'Unable to add to cart. Please try again.');
    }
  }
  // Window capture precedes the app's document capture, including after section replacement.
  window.addEventListener('click', event => {
    const button = event.target.closest?.(selector);
    const form = button?.form || button?.closest('form');
    if (!isAddForm(form)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    checkout(form, button);
  }, true);
  window.addEventListener('submit', event => {
    const form = event.target;
    if (!isAddForm(form)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    checkout(form, event.submitter || form.querySelector(selector));
  }, true);
  window.addEventListener('pageshow', event => { if (event.persisted) pending = false; });
})();
